module.exports = __webpack_public_path__ + "static/media/transiluminator-warning.5bc15738.svg";